import script from "./ManageBot.vue?vue&type=script&setup=true&lang=js"
export * from "./ManageBot.vue?vue&type=script&setup=true&lang=js"

import "./ManageBot.vue?vue&type=style&index=0&id=4cacb2b6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cacb2b6"]])

export default __exports__